import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Vuelidate from 'vuelidate'
import "bootstrap-vue/dist/bootstrap-vue.css"
import "bootstrap/dist/css/bootstrap.css"
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import Dashboard from "@/components/layoutes/Dashboard";
import Admin from "@/components/layoutes/Admin";
import Default from "@/components/layoutes/Default";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import interceptorsSetup from './helpers/interceptors'
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import Notifications from "./components/NotificationPlugin";
import MaterialDashboard from "./material-dashboard";
import Chartist from "chartist";
import VueMaterial from 'vue-material'
import { initSessionTimeout} from "@/helpers/sessionTimeout";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);
Vue.component('dashboard-layout', Dashboard);
Vue.component('admin-layout', Admin);
Vue.component('default-layout', Default);
Vue.prototype.$Chartist = Chartist;
Vue.config.productionTip = false
Vue.use(VueMaterial);
Vue.use(MaterialDashboard);
Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(Notifications);


interceptorsSetup()
new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    // If user is already logged in (page refresh), start session timeout
    const token = this.$store.state.access_token || localStorage.getItem('access_token');
    if (token) {
      initSessionTimeout(15);
    }
  },
  data: {
    Chartist: Chartist,
  },
}).$mount('#app')
